import {
  ComponentConfig,
  LayoutTypes,
  ComponentType,
  FlexDirection,
  ActionType,
} from "../services/types/ComponentTypes";

export const screen_131_cash_and_bank: ComponentConfig[] = [
  {
    componentType: LayoutTypes.SCREEN_GROUP,
    title: "Cash and bank",
    style: {
      backgroundColor: "#F9FAFB", // bg-gray-50 from design system
    },
    childComponents: [
      {
        componentType: LayoutTypes.GROUP,
        style: {
          backgroundColor: "#ffffff",
          direction: FlexDirection.COLUMN,
          borderRadius: 12, // Design system: rounded-lg (12px)
          padding: 16, // Design system: p-4 (16px)
        },
        childComponents: [
          {
            componentType: ComponentType.SUMMARY_LIST,
            titleValue: "ledger_name",
            Name: "Ledgers",
            BindValue: "grid_stock",
            SummeryActions: [
              {
                Action: {
                  Action: "Navigate",
                  Navigate:
                    "modulev1/heads_balance_add_for_chart_of_accounts_head/<id>",
                },
                ActionType: "Edit",
                ScreenId: "133",
              },
              {
                Action: {
                  Action: "PDF",
                  Settings: "cash_ledger_transactions",
                },
                ActionType: ActionType.PDF_DOWNLOAD,
                tooltip: "Download PDF",
              },
            ],
            Form: {
              Name: "Ledgers",
              TableName: "ledger_balances",
              DisplayName: "Ledgers",
              Query:
                "SELECT ledger_balances.id,ledgers.id as ledgerid ,ledgers.ledger_name,lookup_items.name ,ledger_balances.opening_balance,COALESCE( ledger_balances.current_balance,0) AS current_balance, COALESCE(ledger_balances.opening_balance, 0) + COALESCE(( SELECT SUM(COALESCE(t.credit, 0) - COALESCE(t.debit, 0)) FROM transactions t WHERE t.reference_id = ledgers.id AND t.accounting_year_id = ledger_balances.financial_year AND t.transaction_branch_id = ledger_balances.transaction_branch_id AND COALESCE(t.active, 0) = 0 ), 0) AS amount FROM ledgers  LEFT JOIN ledger_group ON ledger_group.id=ledgers.group_id  INNER JOIN `ledger_balances` ON `ledger_balances`.ledger_id=ledgers.id INNER JOIN `lookup_items` ON lookup_items.id=ledger_balances.`financial_year` WHERE CAST(ledger_group.id AS CHAR) IN ('1', '2') and ledger_balances.soft_delete=0  and ledgers.ledger_name  <> 'Sundry creditor' AND ledger_balances.transaction_branch_id = '<branch_id>'",
              Fields: [
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "id",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "id",
                  BindValue: "id",
                  Json_Attribute: "ledgerid",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: false,
                  IsPrimary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Ledger",
                  IsMandatory: true,
                  BindValue: "ledger",
                  Json_Attribute: "ledger_name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Financial year",
                  IsMandatory: true,
                  BindValue: "accounting_years",
                  Json_Attribute: "name",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Opening balance",
                  IsMandatory: true,
                  BindValue: "txt_opening_balance",
                  Json_Attribute: "opening_balance",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Closing balance",
                  IsMandatory: true,
                  BindValue: "current_balance",
                  Json_Attribute: "current_balance",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
                {
                  IncludeLabel: true,
                  Label: "Amount",
                  IsMandatory: true,
                  BindValue: "amount",
                  Json_Attribute: "amount",
                  componentType: ComponentType.TEXT_FIELD,
                  showInSummary: true,
                },
              ],
            },
          },
        ],
      },
    ],
  },
];
